import React from "react";

const Head = ({ heading, subheading, content,subcontent }) => {
  return (<section className="px-4 py-1 md:px-8 lg:px-16  md:py-5 text-center flex flex-col gap-4">
    <h2 className="text-secondary  text-3xl md:text-5xl font-bold">{heading}</h2>
    <h3 className="text-[#578d48] text-lg md:mt-3 md:text-2xl font-semibold">{subheading}</h3>
    <p className="text-gray-700 md:mt-3 text-sm md:text-lg">{content}</p>
    <p className="text-gray-700 md:mt-3 text-sm md:text-xl">{subcontent}</p>

  </section>
     );
};

export default Head;
